import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { StoryFacade } from "@hermes/states/story-state";

@Injectable()
export class HomePageResolver {
    constructor(private storyFacade: StoryFacade) {}

    public resolve(): Observable<boolean> {
        this.storyFacade.fetchHomepageStory();
        // Resolve only when it's not loading.
        return this.storyFacade.selectLoadingWhenFalse();
    }
}
